const fakeData = [
	{ id: 1, name: 'Child Support', photo: `${process.env.PUBLIC_URL}/assets/images/childSupport.png` },
	{ id: 2, name: 'Refuge Shelter', photo: `${process.env.PUBLIC_URL}/assets/images/refuseShelter.png` },
	{ id: 3, name: 'New Books', photo: `${process.env.PUBLIC_URL}/assets/images/newBooks.png` },
	{ id: 4, name: 'IT Help', photo: `${process.env.PUBLIC_URL}/assets/images/ITHelp.png` },
	{ id: 5, name: 'Animal Shelter', photo: `${process.env.PUBLIC_URL}/assets/images/animalShelter.png` },
	{ id: 6, name: 'Baby Sit', photo: `${process.env.PUBLIC_URL}/assets/images/babySit.png` },
	{ id: 7, name: 'Bird House', photo: `${process.env.PUBLIC_URL}/assets/images/birdHouse.png` },
	{ id: 8, name: 'Clean Water', photo: `${process.env.PUBLIC_URL}/assets/images/cleanWater.png` },
	{ id: 9, name: 'Clean Park', photo: `${process.env.PUBLIC_URL}/assets/images/clearnPark.png` },
	{ id: 10, name: 'Drive Safety', photo: `${process.env.PUBLIC_URL}/assets/images/driveSafety.png` },
	{ id: 11, name: 'River Clean', photo: `${process.env.PUBLIC_URL}/assets/images/riverClean.png` },
	{ id: 12, name: 'Food Charity', photo: `${process.env.PUBLIC_URL}/assets/images/foodCharity.png` },
];

export default fakeData;
